import { ref } from 'vue';
import { getCityInfo, getMobileCodeInfo } from '@/apis/BCBD';

const getSelectList = (result, code) => {
    const telCode = ref([]);
    const cityOptions = ref([]);
    const countyOptions = ref([]);
    if (result) {
        const {
            cityList,
            countyList,
            telCodeList,
        } = result;
        telCode.value = telCodeList;
        countyOptions.value = countyList;
        cityOptions.value = cityList;
    } else {
        // 手機國碼
        getMobileCodeInfo(code).then(res => {
            telCode.value = res.data.mobileCodeList.map(i => {
                i.label = `${i.text}(+${i.value})`;
                return i;
            });
        });

        // 縣市資訊
        getCityInfo(code).then(res => {
            const { cityInfoList } = res.data;
            countyOptions.value = cityInfoList.reduce((group, item) => {
                const { city } = item;
                group[city] = group[city] || [];
                group[city].push(item);
                return group;
            }, {});
            cityOptions.value = Object.keys(countyOptions.value);
            Object.values(countyOptions.value).forEach(item => {
                item.forEach(i => {
                    i.value = i.area;
                });
            });
        });
    }
    return {
        telCode,
        cityOptions,
        countyOptions,
    };
};

const getTelSelectList = (result, code) => {
    const telCode = ref([]);
    if (result) {
        const { telCodeList } = result;
        telCode.value = telCodeList;
    } else {
        // 手機國碼
        getMobileCodeInfo(code).then(res => {
            telCode.value = res.data.mobileCodeList.map(i => {
                i.label = `${i.text}(+${i.value})`;
                return i;
            });
        });
    }
    return { telCode };
};
export default getSelectList;
export { getTelSelectList };
